import axios from '@/libs/axios';
import { useQuery } from '@tanstack/react-query';
import { ListQueryKey, Urls } from '../constant';
//
export const selection = data => {
  const {
    pageIndex,
    pageSize,
    ...filters
  } = data;
  return axios.post(Urls.selectUrl, {
    page: pageIndex,
    page_size: pageSize,
    filters: filters,
    orders: {
      weight: {
        desc: true,
        enable: true
      }
    }
  });
};
//
export const useSelect = ({
  params,
  config
}) => {
  return useQuery([ListQueryKey, params], () => selection(params), config);
};